<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :handelAdd="showAddModal"
      :collection="formCollection"
      :ableSearch="ableSearch"
      :ableAdd="ableAdd"
    ></search-form>
    <a-modal
      width="600px"
      v-model:open="open"
      :title="(isEdit ? '编辑' : '新增') + pageName"
      :footer="null"
      :destroyOnClose="true"
      :keyboard="false"
      class="action-form-model-small"
    >
      <action
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :editData="editData"
        :data="tableData"
        :idField="idField"
      ></action>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'state'">
          {{ codeToText(record.state, Enum.stateEquipmentType.value) }}
        </template>
        <template v-if="column.key === 'type'">
          {{ codeToText(record.type, Enum.gateType.value) }}
        </template>
        <template v-if="column.key === 'is_security_check'">
          {{ codeToText(record.is_security_check, yesOrNot) }}
        </template>
        <template v-if="column.key === 'entrances_type'">
          {{ codeToText(record.entrances_type, Enum.entrancesType.value) }}
        </template>
        <template v-if="column.key === 'location'">
          {{ record.lng }}，{{ record.lat }}
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a-button
              @click="showEditModal(record)"
              :loading="loadingRecord === record"
              v-if="ableEdit"
            >
              编辑
            </a-button>
            &nbsp;&nbsp;
            <a-popconfirm
              title="确认删除？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="delRow(record)"
              v-if="ableDelete"
            >
              <a-button danger>删除</a-button>
            </a-popconfirm>
          </span>
        </template>
      </template>
    </a-table>
  </div>
</template>
<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import {
    getData,
    deleteData,
    getDetail,
  } from '@/api/equipment_management/gate'
  import action from './action'
  import { message } from 'ant-design-vue'
  import { codeToText } from '@/utils/format'
  import searchForm from '@/components/search_form'
  import { yesOrNot } from '@/utils/common'
  //初始化
  const pageName = '闸机设备'
  const idField = 'id' //响应数据的id的字段名
  const store = useStore()
  const Enum = toRefs(store.state.common)

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableSearch = computed(() =>
    !!permissionList.value?.find(item => item.code === 'gateDevice:list')
  )
  const ableAdd = computed(() =>
    !!permissionList.value?.find(item => item.code === 'gateDevice:add')
  )
  const ableEdit = computed(() =>
    !!permissionList.value?.find(item => item.code === 'gateDevice:edit')
  )
  const ableDelete = computed(() =>
    !!permissionList.value?.find(item => item.code === 'gateDevice:delete')
  )

  //1、搜索框
  const formCollection = [
    {
      type: 'input',
      field: 'number',
      label: '编号',
    },
    {
      type: 'input',
      field: 'name',
      label: '名称',
    },
    {
      type: 'select',
      field: 'type',
      storeOptions: 'gateType',
      label: '闸机类型',
      defaultValue: -1,
      width: '130px',
    },
    {
      type: 'select',
      field: 'entrances_type',
      storeOptions: 'entrancesType',
      label: '出入口归属',
      defaultValue: -1,
      width: '130px',
    },
    {
      type: 'select',
      field: 'state',
      storeOptions: 'stateEquipmentType',
      label: '在线状态',
      defaultValue: -1,
      width: '130px',
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
    const params = {
      ...searchFormRef.value.formState
    }
    store.commit('search/setEquipGate', params)
  }

  //2、表格
  const columns = [
    {
      title: '编号',
      dataIndex: 'number',
      key: 'number',
      align: 'left',
    },
    {
      title: '设备名称',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
    },
    {
      title: '位置',
      key: 'location',
      align: 'left',
    },
    {
      title: '出入口归属',
      key: 'entrances_type',
      align: 'left',
    },
    {
      title: '闸机类型',
      key: 'type',
      align: 'left',
    },
    {
      title: '适用临时预约',
      key: 'is_security_check',
      align: 'left',
    },
    {
      title: '状态',
      key: 'state',
      dataIndex: 'state',
      align: 'left',
    },
    {
      title: '状态最近检查时间',
      dataIndex: 'state_update_time',
      key: 'state_update_time',
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
    })
  }
  
  const cachedSearchParams = computed(() => store.state.search.searchEquipGate)
  onMounted(() => {
    for (const key in cachedSearchParams.value) {
      searchFormRef.value.formState[key] = cachedSearchParams.value[key]
    }
    fetch()
  })

  //3、编辑、添加
  const open = ref(false)
  const isEdit = ref(false)
  const editData = ref(null)

  const showAddModal = () => {
    editData.value = null
    isEdit.value = false
    open.value = true
  }
  const showEditModal = async (data) => {
    loadingRecord.value = data
    const detail = await fetchDetail(data[idField])
    loadingRecord.value = null
    if (detail) {
      editData.value = detail
      isEdit.value = true
      open.value = true
    }
  }

  async function fetchDetail(id) {
    const res = await getDetail({ id })
    if (res.success) {
      return res.data
    } else {
      message.warn('获取详情失败')
    }
  }

  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  //4、删除
  async function delRow(data) {
    const res = await deleteData({ id: data[idField] })
    if (res.success) {
      message.success('删除成功！')
      fetch()
    } else {
      message.warn('删除失败' + res.message)
    }
  }
</script>
